import React,{Component} from 'react';
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Button, Divider,message,Select} from 'antd';
import { getGroup ,editGroup} from '../../model/group/requests';
import {dbFields}  from '../../model/group/column';
import { route } from "../../routes/routes";
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import PasswdReset from '../user/reset';
const Option = Select.Option

export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};


class GroupEdit extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            groupInfo:{},
            customList:[],
            cid:0,
            custom_id:0
        }
    };
    componentDidMount(){
        let id = this.props.match.params.id;
        let groupInfo = {}
        let cid = 0
        getGroup({id:id}).then(res=>{
            if(res.data.code === 200 ){
                groupInfo = res.data.data
                if(groupInfo.customs.length > 0 ){
                    cid = groupInfo.customs[0].id
                    groupInfo.custom_id = cid;
                }
                let parent = groupInfo.parent_id
                if(parent>0){
                    this.handlerLoadCustom(parent)
                }
                this.formRef.current.setFieldsValue(groupInfo);
                this.setState({
                    groupInfo:groupInfo,
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

        // 根据父亲节点加载所有custom信息
    }


    handlerLoadCustom(id){
        let customList = []
        getGroup({id:id}).then(res=>{
            if(res.data.code == 200){
                customList = res.data.data.customs
                    this.setState({
                        customList:customList,
                    })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerSubmit = (e) => {
        // 如果父节点绑定的custom发生改变，那么将需要手动重新为子节点绑定
        let group_id = parseInt(this.props.match.params.id)
        let name = this.formRef.current.getFieldValue(dbFields.name.key);
        let custom_id = this.state.custom_id 
        editGroup({id:group_id,name:name,custom_id:custom_id}).then(res=>{
            if(res.data.code == 200){
                message.success(configs.http.responseMsg.updated)
                setTimeout(()=>{
                    this.props.history.push(route.group.index)
                },1000)
               
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
        
    }
    handlerChange = (item) => {
        this.setState({
            custom_id:item
        })
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    render(){
        const {groupInfo,customList} = this.state
        return (
            <>
                <BreadcrumbCustomer first='Group' second='Edit' />
                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        name:groupInfo.name,
                        custom_id:groupInfo.custom_id
                    }}
                >
                    <Form.Item
                        name= {dbFields.name.key}
                        label={dbFields.name.title}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label={"Custom"} name={"custom_id"}
                        hidden = {groupInfo.parent_id === 0}
                    >
                        <Select
                            onChange={this.handlerChange}
                        >
                            {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}

                        </Select>
                    </Form.Item>                   
                    <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                                type="primary" 
                                style={{background: "#851dd6",color:"white" }}
                                onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>
            
            </>

        )
    }


}

export default GroupEdit;